"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRole = exports.roleScope = exports.compareRoles = exports.sortRoles = exports.isAdminForProgram = exports.formatRoleForDisplay = exports.roleFromString = exports.isOneOf = void 0;
var Role;
(function (Role) {
    Role["OrgAdmin"] = "organization_admin";
    Role["ProgramAdmin"] = "program_admin";
    Role["ProgramCoordinator"] = "program_coordinator";
    Role["Owner"] = "owner";
    Role["Admin"] = "admin";
    Role["DivisionCoordinator"] = "division_coordinator";
    Role["Unknown"] = "unknown";
})(Role || (Role = {}));
var isOneOf = function (orgId, user) {
    var _a;
    var roles = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        roles[_i - 2] = arguments[_i];
    }
    if (user == null) {
        return false;
    }
    return (_a = user.roles) === null || _a === void 0 ? void 0 : _a.some(function (x) { return x.organizationId === orgId && roles.includes(x.type); });
};
exports.isOneOf = isOneOf;
var sortingArr = [
    Role.Owner,
    Role.OrgAdmin,
    Role.Admin,
    Role.ProgramAdmin,
    Role.ProgramCoordinator,
    Role.DivisionCoordinator,
];
function roleFromString(roleStr) {
    switch (roleStr.toLowerCase()) {
        case Role.OrgAdmin:
            return Role.OrgAdmin;
        case Role.ProgramAdmin:
            return Role.ProgramAdmin;
        case Role.ProgramCoordinator:
            return Role.ProgramCoordinator;
        case Role.DivisionCoordinator:
            return Role.DivisionCoordinator;
        case Role.Owner.toLowerCase():
            return Role.Owner;
        case Role.Admin.toLowerCase():
            return Role.Admin;
        default:
            return Role.Unknown;
    }
}
exports.roleFromString = roleFromString;
function formatRoleForDisplay(role) {
    switch (role) {
        case Role.OrgAdmin:
            return 'Organization Admin';
        case Role.ProgramAdmin:
            return 'Program Admin';
        case Role.ProgramCoordinator:
            return 'Program Coordinator';
        case Role.DivisionCoordinator:
            return 'Division Coordinator';
        case Role.Owner:
            return 'Organization Owner';
        case Role.Admin:
            return 'Admin';
        default:
            return '';
    }
}
exports.formatRoleForDisplay = formatRoleForDisplay;
function isAdminForProgram(staff, programId) {
    var programHasAdmin = false;
    staff.forEach(function (staff) {
        if (staff.roles.find(function (e) { return roleFromString(e.type) == Role.ProgramAdmin && parseInt(e.scopeId) == programId; })) {
            programHasAdmin = true;
        }
    });
    return programHasAdmin;
}
exports.isAdminForProgram = isAdminForProgram;
function sortRoles(roles) {
    return roles.sort(compareRoles);
}
exports.sortRoles = sortRoles;
function compareRoles(a, b) {
    return sortingArr.indexOf(a) - sortingArr.indexOf(b);
}
exports.compareRoles = compareRoles;
function roleScope(role) {
    var roleScopeParts = role.split('_');
    return roleScopeParts.length == 2 ? roleScopeParts[0] : 'organization';
}
exports.roleScope = roleScope;
function getRole(user, orgId) {
    return formatRoleForDisplay(user.roles.find(function (role) { return +role.organizationId === +orgId; }).type);
}
exports.getRole = getRole;
exports.default = Role;
